import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import FleetNew from './components/FleetNew';
import HowItWorks from './components/HowItWorks';
import Destinations from './components/Destinations';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FleetDetail from './components/FleetDetail';
import DestinationDetail from './components/DestinationDetail';
import BlogRouter from './blogs';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);

      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      window.requestAnimationFrame(() => {
        const delayedElement = document.querySelector(hash);
        if (delayedElement) {
          delayedElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

// Home Page Component
const HomePage = () => (
  <>
    <Navbar />
    <Hero />
    <About />
    <FleetNew />
    <HowItWorks />
    <Destinations />
    <Testimonials />
    <FAQ />
    <Contact />
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App overflow-x-hidden">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog/*" element={<BlogRouter />} />
          <Route path="/blogs/*" element={<BlogRouter />} />
          <Route path="/fleet/:id" element={<FleetDetail />} />
          <Route path="/destination/:id" element={<DestinationDetail />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
